import React, { useState, useEffect } from "react";
import { purchaseOfferService } from "../purchaseOfferService";
import { usePurchaseOfferModel } from "../purchaseOfferModel";
import { IPurchaseOfferFields } from "../purchaseOfferType";
import { momentFormat } from '@/utils/utils';
import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";
import useGlobalModel from "@/model/globalModel";

interface PropsType {
  onGetGoodPrintVisible: boolean;
  setOnGetGoodPrintVisible: (visible: boolean) => void;
}

export const OnGetGoodPrint = (props: PropsType) => {
  const { onGetGoodPrintVisible, setOnGetGoodPrintVisible } = props;
  const { descRows, selectedRow } = usePurchaseOfferModel();
  const [groupedData, setGroupedData] = useState<any>([]);
  const [formVal, setFormVal] = useState<any>({});
  useEffect(() => {
    if (onGetGoodPrintVisible) {
      purchaseOfferService.one(selectedRow.id as string).then((res: any) => {
        let { details, ...formVal } = res.retData;
        setGroupedData(details);
        setFormVal(formVal)
        print();
      });
    }
  }, [onGetGoodPrintVisible]);

  const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()
  const print = () => {
    const el: HTMLElement | null = document.getElementById('offerPrint-container1');
    const iframe: HTMLIFrameElement = document.createElement('iframe');
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write('<link rel="stylesheet" type="text/css" href="./offerPrint.css">');
      doc.write(el?.innerHTML || '');
      doc.close();
    }

    iframe.contentWindow?.addEventListener('afterprint', () => {
      document.body.removeChild(iframe);
      setOnGetGoodPrintVisible(false);
    });

    iframe.contentWindow?.focus();
    iframe.onload = () => {
      iframe.contentWindow?.print();
    };

    if (navigator.userAgent.indexOf("MSIE") > 0) {
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 100);
    }
  };

  return (
    <div style={{ display: 'none' }}>
      <div id="offerPrint-container1" className="offerPrint-container">
        <div className="print-page">
          <div style={{ textAlign: 'center', fontSize: 16, fontFamily: "FangSong", fontWeight: 'bolder', margin: "15px 0px" }}>
            {`${shopName}汽车配件采购项目送货单`}
          </div>
          <div style={{ marginTop: 10 }}>
            <span style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'bolder' }}>采购批次：{formVal?.batchCode}</span>
            <span style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'bolder', float: 'right' }}>送货时间：{formVal?.createTime == undefined ? "" : momentFormat(formVal?.createTime, "YYYY.MM.DD HH:mm")}</span>
          </div>
          <table className="mingxi" style={{ border: "1px solid black" }}>
            <thead>
              <tr style={{ lineHeight: 1.2 }}>
                {['序号', '配件编码', '产品名称', '品牌', '车型', '型号', '单位', '数量', '备注'].map((th, i) => (
                  <th key={i} style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal' }}>{th}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {groupedData.map((row: IPurchaseOfferFields, rowIndex: number) => (
                <tr key={rowIndex} style={{ lineHeight: 1 }}>
                  <td style={{ width: 28, fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{rowIndex + 1}</td>
                  <td style={{ fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'nowrap' }}>{row.materialCode}</td>
                  <td style={{ fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'nowrap' }}>{row.materialName}</td>
                  <td style={{ fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'nowrap' }}>{row.brandCode ? row.brandName : ''}</td>
                  <td style={{ fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'nowrap' }}>{row.model}</td>
                  <td style={{ fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'nowrap' }}>{row.vehicleModel}</td>
                  <td style={{ fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'nowrap' }}>{row.unitCode ? row.unitName : ''}</td>
                  <td style={{ fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'nowrap' }}>{row.planNum}</td>
                  <td style={{ fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'nowrap' }}>{row.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ display: "flex", marginTop: 10, marginBottom: 5 }}>
            <div style={{ flex: 1, fontSize: 12, fontFamily: "FangSong", fontWeight: 'bolder' }}>制表人：</div>
            <div style={{ flex: 1, fontSize: 12, fontFamily: "FangSong", fontWeight: 'bolder' }}>审核人：</div>
          </div>
          <div style={{ display: "flex", marginTop: 10, marginBottom: 5 }}>
            <div style={{ flex: 1, fontSize: 12, fontFamily: "FangSong", fontWeight: 'bolder' }}>送货公司：</div>
            <div style={{ flex: 1, fontSize: 12, fontFamily: "FangSong", fontWeight: 'bolder' }}>接收站点：</div>
          </div>
        </div>
      </div>
    </div>
  );
};